export default "__VITE_ASSET__Bi1YtJqr__"